module.exports = __webpack_public_path__ + "static/email-mobile-083f79d003c250305ef1a23de93a0168.jpg";